// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"916":"f8491130","1266":"a0507ec5","9627":"a0507ec5"}[chunkId] + ".chunk.css";
};